import Vue from 'vue'
import Router from 'vue-router'
// NOT FOUND
const NotFound = () => import('@/pages/error/NotFound');

//LOGIN
const Login = () => import('@/pages/application/login/Login')
const EmergencyResume = () => import('@/pages/application/EmergencyResume')
const Maintenance = () => import('@/pages/application/Maintenance')

// ADMIN
const TheAdminContainer = () => import('@/containers/TheAdminContainer');
const Accounts = () => import('@/pages/administrator/Accounts');
const SendTimeReport = () => import('@/pages/administrator/SendTimeReport');
const EmergencyControl = () => import('@/pages/administrator/EmergencyControl');
const RecoveryForm = () => import('@/pages/application/login/RecoveryForm');

//USERS 
const TheContainer = () => import('@/containers/TheContainer')
const Home = () => import('@/pages/application/Home');
const Event = () => import('@/pages/application/Events');
const EventDetail = () => import('@/pages/application/EventDetail');

//Registro de invitados externo
const ExternalGuestRegistration = () => import('@/pages/application/ExternalGuestRegistration');
const ExternalDownloadTickets = () => import('@/pages/application/ExternalDownloadTickets');
const ScanTickets = () => import('@/pages/application/ScanTickets');

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/registro/:event_slug/:code',
      name: 'Registro Externo',
      meta: {
        is_public: true,
      },
      component: ExternalGuestRegistration
    },
    {
      path: '/:code/get-tickets',
      name: 'external-download-tickets',
      meta: {
        is_public: true,
      },
      component: ExternalDownloadTickets
    },
    {
      path: '/login',
      name: 'Login',
      meta: {
        is_public: true,
      },
      component: Login
    },
    {
      path: '/maintenance',
      name: 'maintenance',
      meta: {
        is_public: true,
      },
      component: Maintenance
    },
    {
      path: '/emergency/resume',
      name: 'emergency-resume',
      meta: {
        is_public: true,
      },
      component: EmergencyResume
    },
    {
      path: '/account/recover-password/:id/:code',
      name: 'Recupera tu Contraseña',
      meta: {
        is_public: true,
      },
      component: RecoveryForm
    },    
    {
      path: '/admin',
      component: TheAdminContainer,
      children: [
        {
          path: '',
          redirect: 'accounts'
        },
        {
          path: 'accounts',
          name: 'Cuentas',
          component: Accounts,
          meta: { is_public: false, is_admin: true }
        },
        {
          path: 'send-time-report',
          name: 'Reporte de horarios de envío',
          component: SendTimeReport,
          meta: { is_public: false, is_admin: true }
        },
        {
          path: 'emergency-control',
          name: 'Botón de emergencia',
          component: EmergencyControl,
          meta: { is_public: false, is_admin: true }
        }
      ]
    },
    {
      path: '/',
      component: TheContainer,
      meta: {
        is_public: false,
        is_admin: false,
      },
      children: [
        {
          path: '',
          redirect: 'home'
        },
        {
          path: 'home',
          name: 'Inicio',
          component: Home,
          meta: {
            is_public: false,
            is_admin: false,
          },
        },
        {
          path: 'events',
          name: 'Eventos',
          component: Event,
          meta: {
            is_public: false,
            is_admin: false,
          },
        },
        {
          path: 'events/:id/detail',
          name: 'event-detail',
          component: EventDetail,
          meta: {
            is_public: false,
            is_admin: false,
          },
        },
        {
          path: 'events/:id/scan',
          name: 'scan-tickets',
          component: ScanTickets,
          meta: {
            is_public: false,
            is_admin: false,
          },
        }

      ]
    },
    {
      path: '*',
      name: '404',
      meta: {
        is_public: true,
      },
      component: NotFound
    }
  ]
})